(function () {
  'use strict';
  function initialize(root) {
    root.querySelectorAll('.lt-mobile-nav').forEach(function (menu) {
      if (menu.dataset.nativeInitialized) return;
      menu.dataset.nativeInitialized = 'true';
      menu.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
}());
